// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-grid-header[data-v-55f36e60]{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
